import module from 'fan/proyecto/module.js'
import moment from 'moment'

export class FanProyectoReportesColaboradoresService {
  constructor($http) {
    this.$http = $http
  }

  get(idProyecto, config) {
    return this.$http.get('/api2/proyecto/reportes/colaboradores', {
      params: {
        id_proyecto: idProyecto,
        activo: config.activo,
        documentos: config.documentos && 1 || 0,
        fecha_alta_ini: config.fecha_alta_ini && moment(config.fecha_alta_ini).format('YYYY-MM-DD') || undefined,
        fecha_alta_fin: config.fecha_alta_fin && moment(config.fecha_alta_fin).format('YYYY-MM-DD') || undefined,
        fecha_baja_ini: config.fecha_baja_ini && moment(config.fecha_baja_ini).format('YYYY-MM-DD') || undefined,
        fecha_baja_fin: config.fecha_baja_fin && moment(config.fecha_baja_fin).format('YYYY-MM-DD') || undefined,
        ultima_nomina: config.ultima_nomina && 1 || 0,
      },
      download: true,
    })
  }
}

module.service('FanProyectoReportesColaboradoresService', FanProyectoReportesColaboradoresService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Reportes/Colaboradores.js